import { render, staticRenderFns } from "./templete1.vue?vue&type=template&id=4fba276e&scoped=true"
import script from "./templete1.vue?vue&type=script&lang=js"
export * from "./templete1.vue?vue&type=script&lang=js"
import style0 from "./templete1.vue?vue&type=style&index=0&id=4fba276e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fba276e",
  null
  
)

export default component.exports